import request from 'services/request'
import _get from 'lodash/get'
import { fromJS } from 'immutable'
import { createAuthorization } from 'services/auth'

export const TYPES = Object.freeze({
  COMMENT: 'COMMENT',
  PORTAL: 'PORTAL',
  CHAT: 'CHAT',
})

export const RESOLVER_ACTIONS = Object.freeze({
  ACCOUNT_TERMINATED: 'ACCOUNT_TERMINATED',
  ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED',
  PORTAL_LOCKED: 'PORTAL_LOCKED',
  NONE: 'NONE',
})

export const ACCUSATION_CODES = Object.freeze({
  P001: 'P001',
  P002: 'P002',
  P003: 'P003',
  P004: 'P004',
  P005: 'P005',
})

export const ACCUSATION_REASONS = Object.freeze({
  P001: 'Inappropriate Avatar',
  P002: 'Impersonation',
  P003: 'Poor Conduct',
  P004: 'Bad Videos',
  P005: 'Spammy',
})

/**
 * get user abuse reports
 */
export async function getUserAbuseReports ({
  auth, server, accusedUid, accuserUid, resolved, p = 1, pp = 100,
}) {
  const res = await request
    .get(`${server}/v1/user-abuse/`)
    .query({
      accusedUid, accuserUid, resolved, p, pp,
    })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * resolve user abuse report
 */
export async function resolveUserAbuseReport ({
  auth, server, reportId, resolverAction,
}) {
  const res = await request
    .put(`${server}/v1/user-abuse/${reportId}`)
    // .query({ resolved, p, pp })
    .send({ resolverAction })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * get user abuse reports
 */
export async function getUserAbuseUnresolvedCount ({ auth, server }) {
  const res = await request
    .get(`${server}/v1/user-abuse/unresolved-count`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}
